<template>
    <div class="popup" :class="{ 'modal-in': isShow, 'modal-out': !isShow}" id="bookingDetailShorex">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>升级精品游</p>
            <a class="shorexDetail-returnButton" @click="onGoBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="shorexDetail-content">
            <div class="pop-img">
                <div class="pop-sight">
                    <img style="" src="https://resource.rcclchina.com.cn/shorex/shorex-title-mobile.png" alt="">
                </div>
            </div>
            <div class="shorex-body">
                <div class="rule-item">
                    <div class="rule-item-line"></div>
                    <p>请在线升级付费精品游套餐</p>
                </div>

                <div class="nav-item">
                    <ul class="nav-bar nav-bar-it">
                        <template v-for="(shorex, i) in shorexes">
                        <li class="shorexTitle active-2"  v-if="shorex.outOfStock == false" :key="('shorexTab_'+i)"
                        :class="{ active: selectedShorexId == shorex.id}"
                        @click="selectedShorexId=shorex.id">
                            <div>{{shorex.shorexName}}</div>
                            <div>{{shorex.price}}美元/人</div>
                        </li>
                        </template>
                    </ul>
                    <ul class="shorex-list" v-for="(shorex, i) in shorexes" :key="('shorex_'+i)"
                    v-show="selectedShorexId == shorex.id">
                        <li v-for="(tour, j) in shorex.shorexTours" :key="('tour_'+i+'_'+j)">
                            <div class="rule-item shorex-item">
                                <div class="rule-item-line"></div>
                                <p>{{tour.shorexName}}</p> <span class="time"></span>&nbsp;&nbsp;时长: {{tour.duration}}
                            </div>
                            <div class="img-desc">
                                <img :src="tour.image" />
                                <div class="desc" v-html="tour.shorexDescription">

                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="notice-bottom">
                <div class="no-title">注:</div>
                <div class="items-bottom">
                    <span class="parah-num">1)</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。<br/>
                    <span class="parah-num">2)</span>目的地产品及行程可能受天气、航次情况、交通、政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。<br/>
                    <span class="parah-num">3)</span>皇家行前订目前只提供全程观光优惠套餐。您可于登船后购买单一港口观光产品。优惠套餐与单一港口观光产品均数量有限，先到先得。<br/>
<!--                    <span class="parah-num">3)</span>关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。-->
                </div>
            </div>
        </div>
        <div class="fix-bottom" v-if="amount > 0">
            <div class="fix-tiny">1间  |  <span id="shorexTotalPrice">{{amount}}</span>&nbsp;美元&nbsp;(上船自动房卡扣款)</div>
            <div class="fix-btn order-btn" @click="submitShorex()">升级精品游</div>
        </div>

    </div>
</template>

<script>
import api from '@/api'
export default {
    name: "BookingDetailShorex",
    props: {
        shorexes: {
            type: Array
        },
        booking: {
            type: Object
        },
        onGoBack: {
            type: Function
        },
        onSelectShorex: {
            type: Function
        },
        isShow: {
            type: Boolean
        }
    },
    data () {
        return {
            selectedShorexId: 0
        }
    },
    methods: {
        async submitShorex() {
            const requestData = {
                viewModel: [{
                    bookingId: this.booking.bookingId,
                    shorexId: this.selectedShorexId
                }]
            }
            this.$loading.show()
            const { success, errMsg } = await api.booking.selectShorex(requestData)
            this.$loading.hide()
            if (success) {
                this.$alert.show('升级成功', {
                    confirmCallBack: ()=> {
                        this.onSelectShorex(this.selectedShorex)
                    }
                })
            }else{
                if (errMsg && errMsg.length > 0) {
                    this.$alert.show(errMsg)
                }
            }
            console.error(errMsg)
        }
    },
    computed: {
        selectedShorex () {
            return this.shorexes.find(r=>r.id == this.selectedShorexId)
        },
        amount () {
            if (!this.booking || !this.booking.bookingGuests
            || !this.selectedShorex || !this.selectedShorex.price) return 0
            return this.selectedShorex.price * this.booking.bookingGuests.length
        }
    },
    watch: {
        shorexes (newValue) {
            if (newValue && newValue.length > 0) {
                this.selectedShorexId = newValue[0].id
            }
        }
    }
}
</script>

<style lang="less" scoped>
#bookingDetailShorex.popup {
    position: fixed;
    transform: translate3d(100%, 0, 0);
    display: block;
    z-index: 10401;
    overflow-y: hidden;
}
#bookingDetailShorex.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#bookingDetailShorex.modal-out {
    transform: translate3d(100%, 0, 0);
}

#bookingDetailShorex {
    li {
        list-style: none;
    }
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            > img {
                width: 33%;
            }
        }
    }
    .shorexDetail-content {
        overflow-y: scroll;
        padding-bottom: 50px;
        height: 100%;
    }
    .pop-img {
        padding: 50px 0 0;
        background: #f6f7f8;
        img {
            max-width: 375px;
            width: 100%;
        }
    }
    .shorex-body {
        .rule-item {
            display: flex;
            align-items: center;
            padding: 17px 0 13px;
            font-size: 14px;
            line-height: 20px;
            color: #4A90E2;
            padding-left: 20px;
            position: relative;
            letter-spacing: 0;
            background-color: #fff;
            .rule-item-line {
                width: 3px;
                height: 12px;
                margin-right: 6px;
                background-color: #4A90E2;
            }
            p {
                margin: 0;
                font-weight: bold;
            }
        }
        .nav-item {
            .nav-bar.nav-bar-it {
                display: flex;
                justify-content: space-between;
                width: 100%;
                padding: 0 20px;
                background-color: #fff;
                overflow-x: auto;
              gap: 16px;
                li.active-2 {
                    width: 50%;
                    height: 44px;
                    text-align: center;
                    border-top-left-radius: 8px;
                    border-bottom-right-radius: 8px;
                    padding-top: 4px;
                    div {
                        color: #333;
                        font-size: 12px;
                        white-space: nowrap;
                    }
                }
                li.active-2:nth-child(2) {
                    position: relative;
                    left: -10px;
                    background: #fff;
                }
                li.active-2.active {
                    background: #4A90E2;
                    div {
                        color: #fff;
                    }
                }

            }
        }
        .shorex-list {
            background: #f6f7f8;
            padding-bottom: 1px;
            li {
                background: #fff;
                margin-bottom: 14px;
                padding-bottom: 13px;
                position: relative;
                padding-left: 20px;
                padding-right: 19px;
                .shorex-item {
                    padding: 10px 0px;
                }
                span.time {
                    content: url('https://resource.rcclchina.com.cn/bookingPay/time.jpg');
                    width: 13px;
                    height: 13px;
                    margin: 0px 8px;
                }
                .img-desc {
                    img {
                        max-width: 375px;
                        width: 100%;
                        margin-bottom: 2px;
                    }
                    .desc {
                        font-size: 12px;
                        color: #666;
                        line-height: 22px;
                    }
                }

            }
        }

    }

    .notice-bottom {
        // display: flex;
        padding: 10px 16px 20px;
        font-size: 12px;
        color: #666;
        .parah-num {
            display: inline-block;
            width: 15px;
        }
    }

    .fix-bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        .fix-tiny {
            color: #fff;
            height: 50px;
            background: #4A90E2;
            padding: 0 0 0 14px;
            font-size: 14px;
            line-height: 50px;
            display: inline-block;
            vertical-align: middle;
            width: 70%;
             > span {
                font-size: 16px;
                font-weight: 400;
            }
        }
        .fix-btn {
            height: 50px;
            background: #FEBC10;
            font-size: 14px;
            line-height: 50px;
            text-align: center;
            display: inline-block;
            width: 30%;
        }
    }
}
</style>

<style lang="less">
#bookingDetailShorex .shorex-body .shorex-list li .img-desc .desc {
    font-size: 12px !important;
    color: #666;
    line-height: 22px !important;
}
</style>
